import React from 'react'
import SearchMovies from './SearchMovies'

const SearchMoviesPage = () => {
  return (
    <div>
        <SearchMovies />
    </div>
  )
}

export default SearchMoviesPage